// import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp'
// import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown'
// import DragHandleIcon from '@mui/icons-material/DragHandle'
// import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
// import type { SvgIconComponent } from '@mui/icons-material'
// import { ApiGetAdminList, ApiGetTodoStatus, ApiGetTodoTasks, ApiUpdateTodoTasks, ApiUpdateTodoStatus, ApiUpdateTodoChecklist, ApiDeleteTodo, ApiGetTodoActivity } from '../../../apiService/Core/Apicall.tsx'

// export const PRIMARY = '#75724C'

// /** TODO: replace with the logged-in user once this is wired to the API. */
// export const CURRENT_USER_ID = '11106'

// /** Lower-cased statusCode from the API: pending, ongoing, on_hold, reassigned, completed, cancelled (deleted is hidden). */
// export type StatusId = string
// export type Priority = 'high' | 'medium' | 'low'

// export interface TodoUser {
//     id: string
//     name: string
//     initials: string
//     color: string
//     profileUrl:string
// }

// export interface ChecklistItem {
//     todoChecklistItemId?: number,
//     itemText: string,
//     isCompleted: boolean,
//     completedOn?: string,
//     displayOrder: number,
//     isActive: boolean
// }

// export interface ActivityEntry {
//     id: string
//     userId: string
//     type: 'comment' | 'history'
//     text: string
//     createdAt: string // ISO datetime
// }

// export interface TodoTask {
//     id: string
//     key: string
//     title: string
//     description: string
//     status: StatusId
//     assigneeId: string
//     reporterId: string
//     priority: Priority
//     labels: string[]
//     dueDate: string | null // ISO yyyy-mm-dd
//     checklist: ChecklistItem[]
//     timeSpentMinutes: number // total time spent, in minutes
//     completionNote: string | null // the single work note
//     activity: ActivityEntry[]
//     createdAt: string
//     updatedAt: string
// }

// /** Fields a screen is allowed to change. History entries are generated by applyPatch. */
// export type TaskPatch = Partial<Omit<TodoTask, 'id' | 'key' | 'reporterId' | 'createdAt' | 'updatedAt'>>

// export interface StatusConfig {
//     id: StatusId
//     apiId: number // todoTaskStatusId, send this to the API
//     label: string
//     dot: string
//     columnBg: string
//     pillBg: string
//     ink: string
// }

// /**
//  * Users come from the admin API. USERS and USER_BY_ID are filled in place by loadUsers(),
//  * so every screen can keep importing them. Call loadUsers() once from the ToDo page
//  * and re-render when it resolves (see ToDo.tsx).
//  */
// export const USERS: TodoUser[] = []
// export const USER_BY_ID: Record<string, TodoUser> = {}

// const AVATAR_COLORS = ['#75724C', '#1976D2', '#2E7D32', '#9C27B0', '#D84315', '#00838F', '#C2185B', '#5E35B1', '#EF6C00', '#455A64']

// // Stable colour per user id (works for numeric and string ids)
// const colorFor = (id: string) => {
//     let h = 0
//     for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0
//     return AVATAR_COLORS[h % AVATAR_COLORS.length]
// }

// const initialsFor = (name: string) =>
//     name.trim().split(/\s+/).map((w) => w[0]).join('').substring(0, 2).toUpperCase() || '?'

// let usersPromise: Promise<TodoUser[]> | null = null

// /** Fetch users once and cache. Pass force = true to refetch. */
// export function loadUsers(force = false): Promise<TodoUser[]> {
//     if (usersPromise && !force) return usersPromise
//     usersPromise = (async () => {
//         try {
//             const response: any = await ApiGetAdminList('?offset=0&limit=1000')
//             const list: TodoUser[] = (response?.data ?? []).map((item: any) => {
//                 const id = String(item?.userId)
//                 const name = item?.displayName || [item?.firstName, item?.lastName].filter(Boolean).join(' ') || 'Unknown User'
//                 return { id, name, initials: initialsFor(name), color: colorFor(id), profileUrl:item?.profilePicUrl}
//             })
//             USERS.splice(0, USERS.length, ...list)
//             Object.keys(USER_BY_ID).forEach((k) => delete USER_BY_ID[k])
//             list.forEach((u) => (USER_BY_ID[u.id] = u))
//         } catch (error) {
//             console.error('Error during API call:', error)
//             usersPromise = null // allow a retry on the next call
//         }
//         return USERS
//     })()
//     return usersPromise
// }

// /** Safe lookup: accepts a number or string id, returns undefined for unassigned or unknown. */
// export const getUserById = (id?: string | number | null) => (id == null || id === '' ? undefined : USER_BY_ID[String(id)])


// // Statuses come from the API (ordered by displayOrder), so nothing here depends on specific
// // codes. STATUSES and STATUS_BY_ID are filled in place by loadStatuses(), same pattern as USERS.
// // The API has no colours: each status takes the next colour set by position, cycling if there are
// // more statuses than sets. If the API later returns a colour, use it in loadStatuses().
// type StatusColors = Pick<StatusConfig, 'dot' | 'columnBg' | 'pillBg' | 'ink'>
// const STATUS_PALETTE: StatusColors[] = [
//     { dot: '#8A8468', columnBg: '#EFEDE3', pillBg: '#E2DFCC', ink: '#55513A' }, // stone
//     { dot: '#3B7DB8', columnBg: '#E7F0F8', pillBg: '#CFE2F2', ink: '#1B4B75' }, // blue
//     { dot: '#C2851A', columnBg: '#FBF1DC', pillBg: '#F3DFAE', ink: '#6E4305' }, // amber
//     { dot: '#7E5BB0', columnBg: '#F0EAF8', pillBg: '#DED0F0', ink: '#43286B' }, // violet
//     { dot: '#2F8F8F', columnBg: '#E3F3F2', pillBg: '#C6E7E5', ink: '#145250' }, // teal
//     { dot: '#B8527A', columnBg: '#F9E9EF', pillBg: '#F1CFDC', ink: '#6B213F' }, // rose
//     { dot: '#B3402F', columnBg: '#FAEAE7', pillBg: '#F3CFC9', ink: '#6E1E13' }, // red
//     { dot: '#3E8D5F', columnBg: '#E4F2E9', pillBg: '#CBE6D5', ink: '#1C5233' }, // green
// ]
// const P = STATUS_PALETTE
// // Known codes get a fixed colour; any new status code the API adds cycles through the palette.
// const COLOR_BY_CODE: Record<string, StatusColors> = {
//     pending: P[0], // stone
//     ongoing: P[1], // blue
//     on_hold: P[2], // amber
//     reassigned: P[3], // violet
//     completed: P[7], // green
//     cancelled: P[6], // red
// }
// const colorsFor = (id: string, index: number): StatusColors => COLOR_BY_CODE[id] ?? P[index % P.length]

// /** Statuses that count as closed (no longer open work). */
// const CLOSED_CODES = ['completed', 'cancelled']
// /** Statuses never shown as board columns / list groups: DELETED is a soft delete, not a workflow step. */
// const HIDDEN_CODES = ['deleted']

// export const STATUSES: StatusConfig[] = []
// export const STATUS_BY_ID: Record<StatusId, StatusConfig> = {}

// let statusesPromise: Promise<StatusConfig[]> | null = null

// /** Fetch statuses once and cache. Pass force = true to refetch. */
// export function loadStatuses(force = false): Promise<StatusConfig[]> {
//     if (statusesPromise && !force) return statusesPromise
//     statusesPromise = (async () => {
//         try {
//             const response: any = await ApiGetTodoStatus()
//             const list: StatusConfig[] = (response?.data ?? [])
//                 .filter((item: any) => item?.isActive !== false && !HIDDEN_CODES.includes(String(item?.statusCode ?? '').toLowerCase()))
//                 .sort((a: any, b: any) => (a?.displayOrder ?? 0) - (b?.displayOrder ?? 0))
//                 .map((item: any, index: number) => {
//                     const id = String(item?.statusCode ?? '').toLowerCase()
//                     return {
//                         id,
//                         apiId: Number(item?.todoTaskStatusId),
//                         label: item?.statusName ?? id,
//                         ...colorsFor(id, index),
//                     }
//                 })
//             STATUSES.splice(0, STATUSES.length, ...list)
//             Object.keys(STATUS_BY_ID).forEach((k) => delete STATUS_BY_ID[k])
//             list.forEach((st) => (STATUS_BY_ID[st.id] = st))
//         } catch (error) {
//             console.error('Error during API call:', error)
//             statusesPromise = null // allow a retry on the next call
//         }
//         return STATUSES
//     })()
//     return statusesPromise
// }

// /** True for statuses that mean the work is closed (completed or cancelled). */
// export const isFinalStatus = (id: StatusId) => CLOSED_CODES.includes(id)

// /** Default status for new tasks: the first one in display order. */
// export const defaultStatusId = (): StatusId => STATUSES[0]?.id ?? 'pending'

// export const PRIORITIES: Record<Priority, { label: string; color: string; Icon: SvgIconComponent }> = {
//     high: { label: 'High', color: '#B3402F', Icon: KeyboardDoubleArrowUpIcon },
//     medium: { label: 'Medium', color: '#8A5E0E', Icon: DragHandleIcon },
//     low: { label: 'Low', color: '#2F6E9F', Icon: KeyboardDoubleArrowDownIcon },
// }



// // ---------------------------------------------------------------------------
// // Tasks from the API
// // ---------------------------------------------------------------------------

// /**
//  * The server stores Australian local time ("2026-10-29 18:53:57" = Sydney/Melbourne time, +11:00 in daylight saving).
//  * Change this if the server runs in another zone (Australia/Perth, Australia/Sydney ...).
//  */
// export const SERVER_TIME_ZONE = 'Australia/Sydney'

// /** Offset (ms) of a time zone from UTC at the given instant, DST included. */
// function zoneOffsetMs(timeZone: string, at: number): number {
//     const parts = new Intl.DateTimeFormat('en-US', {
//         timeZone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
//     }).formatToParts(new Date(at))
//     const n = (t: string) => Number(parts.find((p) => p.type === t)?.value)
//     return Date.UTC(n('year'), n('month') - 1, n('day'), n('hour'), n('minute'), n('second')) - Math.floor(at / 1000) * 1000
// }

// /**
//  * "2026-10-29 18:53:57" (server time in SERVER_TIME_ZONE) -> real UTC ISO string.
//  * Dates then render in each user's own time zone via new Date(iso) / toLocale*String.
//  */
// const toIso = (v?: string | null) => {
//     if (!v) return ''
//     const m = v.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/)
//     if (!m) return ''
//     const wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] ?? 0))
//     let t = wall - zoneOffsetMs(SERVER_TIME_ZONE, wall)
//     t = wall - zoneOffsetMs(SERVER_TIME_ZONE, t) // second pass settles DST edges
//     return new Date(t).toISOString()
// }

// /**
//  * Users embedded in a task (assignedTo / assignedBy) may not be in the admin list.
//  * Register just id + name so lookups and selects work. Nothing else from the embedded
//  * user object is kept (it carries sensitive fields).
//  */
// function registerUser(u: any): string {
//     if (!u?.userId) return ''
//     const id = String(u.userId)
//     if (!USER_BY_ID[id]) {
//         const name = u.displayName || [u.firstName, u.lastName].filter(Boolean).join(' ') || 'Unknown User'
//         const user: TodoUser = { id, name, initials: initialsFor(name), color: colorFor(id), profileUrl:u.profilePicUrl}
//         USER_BY_ID[id] = user
//         USERS.push(user)
//     }
//     return id
// }

// /** Map one API task to the shape the screens use. */
// export function mapApiTask(t: any): TodoTask {
//     const assigneeId = registerUser(t.assignedTo)
//     const reporterId = registerUser(t.assignedBy)
//     const priority = String(t.priority ?? 'medium').toLowerCase() as Priority
//     return {
//         id: String(t.todoTaskId),
//         key: `TSK-${t.todoTaskId}`,
//         title: t.title ?? '',
//         description: t.description ?? '',
//         status: String(t.todoTaskStatusId?.statusCode ?? '').toLowerCase(),
//         assigneeId,
//         reporterId,
//         priority: PRIORITIES[priority] ? priority : 'medium',
//         labels: [], // not in the list API yet
//         dueDate: t.dueDate ? String(t.dueDate).slice(0, 10) : null,
//         checklist: t.checklistItems?.filter((item:ChecklistItem)=>item?.isActive) ?? [],
//         completionNote: t.completionNote ?? null,
//         timeSpentMinutes: Number(t.timeSpentMinutes) || 0,
//         activity: [], // needs the activity API
//         createdAt: toIso(t.createdOn),
//         updatedAt: toIso(t.modifiedOn || t.createdOn),
//     }
// }

// /** Fetch tasks. Query string format follows ApiGetAdminList; adjust if ApiGetTodoTasks differs. */
// export async function loadTasks(query = '?page=1&limit=1000'): Promise<TodoTask[]> {
//     try {
//         const response: any = await ApiGetTodoTasks(query)
//         return (response?.data ?? []).map(mapApiTask)
//     } catch (error) {
//         console.error('Error during API call:', error)
//         return []
//     }
// }

// // ---------------------------------------------------------------------------
// // Saving: each kind of change has its own API. All of them take ?todoTaskId=<id> as params.
// // ---------------------------------------------------------------------------

// /** Patch keys handled by ApiUpdateTodoTasks. */
// export const DETAIL_KEYS: (keyof TaskPatch)[] = ['title', 'description', 'priority']
// /** Patch keys handled by ApiUpdateTodoStatus (status, reassign, due date, time spent and note). */
// export const STATUS_KEYS: (keyof TaskPatch)[] = ['status', 'assigneeId', 'dueDate', 'timeSpentMinutes', 'completionNote']
// /** Patch key handled by ApiUpdateTodoChecklist. */
// export const CHECKLIST_KEY: keyof TaskPatch = 'checklist'

// const idParam = (task: TodoTask) => `?todoTaskId=${task.id}`

// /** Throw when the server answers with status:false, so callers can roll back. */
// const ensureOk = (response: any) => {
//     if (response?.status === false) throw new Error(response?.message || 'Request failed')
//     return response
// }

// /** 'on_hold' -> 'ON_HOLD' (the API's todoTaskStatusCode) */
// export const statusCodeOf = (id: StatusId) => id.toUpperCase()

// /** Title, description and priority. */
// export async function saveTaskDetails(task: TodoTask) {
//     return ensureOk(
//         await ApiUpdateTodoTasks(idParam(task), {
//             title: task.title,
//             description: task.description,
//             priority: task.priority.toUpperCase(), // URGENT | HIGH | MEDIUM | LOW
//         }),
//     )
// }

// /**
//  * Status, due date, time spent + note. Changing the assignee is a status change to REASSIGNED
//  * (assignedTo is sent whenever the status is REASSIGNED). timeSpent and completionNote go together.
//  */
// export async function saveTaskStatus(task: TodoTask) {
//     const hasWork = task.timeSpentMinutes > 0 || !!task.completionNote
//     return ensureOk(
//         await ApiUpdateTodoStatus(idParam(task), {
//             todoTaskStatusCode: statusCodeOf(task.status),
//             ...(hasWork ? { completionNote: task.completionNote ?? '', timeSpent: task.timeSpentMinutes } : {}),
//             ...(task.dueDate ? { dueDate: task.dueDate } : {}), // yyyy-mm-dd only
//             ...(task.status === 'reassigned' ? { assignedTo: Number(task.assigneeId) } : {}),
//         }),
//     )
// }

// /**
//  * Checklist add / update / delete / tick in one call. Items still in the list are sent as active,
//  * items that were removed are sent with isActive:false, and new items have no todoChecklistItemId.
//  */
// export async function saveTaskChecklist(before: TodoTask, after: TodoTask) {
//     const kept = after.checklist.map((c, i) => ({
//         ...(c.todoChecklistItemId ? { todoChecklistItemId: c.todoChecklistItemId } : {}),
//         itemText: c.itemText,
//         isCompleted: c.isCompleted,
//         displayOrder: i + 1,
//         isActive: true,
//     }))
//     const keptIds = new Set(after.checklist.map((c) => c.todoChecklistItemId).filter(Boolean))
//     const removed = before.checklist
//         .filter((c) => c.todoChecklistItemId && !keptIds.has(c.todoChecklistItemId))
//         .map((c) => ({ todoChecklistItemId: c.todoChecklistItemId, itemText: c.itemText, isCompleted: c.isCompleted, displayOrder: c.displayOrder, isActive: false }))
//     return ensureOk(await ApiUpdateTodoChecklist(idParam(after), { checklistItems: [...removed, ...kept] }))
// }

// export async function deleteTodoTask(task: TodoTask) {
//     return ensureOk(await ApiDeleteTodo(idParam(task)))
// }

// const prettyCode = (code: string) =>
//     code.toLowerCase().split('_').filter(Boolean).map((w) => w[0].toUpperCase() + w.slice(1)).join(' ')

// /** 'PENDING' -> 'Pending' using the loaded status labels, anything else -> 'Some Value'. */
// const prettyValue = (v: string) => STATUS_BY_ID[v.toLowerCase()]?.label ?? (PRIORITIES[v.toLowerCase() as Priority]?.label ?? prettyCode(v))

// /**
//  * One sentence per activity row. The API sends { action, oldValue, newValue, note }.
//  * When the action is a status code (ONGOING, ON_HOLD ...) it reads as a status change;
//  * for any other action it falls back to "<Action>: old -> new", so new action types still show up.
//  */
// function activityText(a: any): string {
//     // const action = String(a?.action ?? '')
//     // const oldV = a?.oldValue ? String(a.oldValue) : ''
//     // const newV = a?.newValue ? String(a.newValue) : ''
//     // const isStatus = !!STATUS_BY_ID[action.toLowerCase()]
//     // let text: string
//     // if (isStatus) text = oldV ? `Changed status from ${prettyValue(oldV)} to ${prettyValue(newV || action)}` : `Set status to ${prettyValue(newV || action)}`
//     // else if (oldV || newV) text = `${prettyCode(action)}: ${oldV ? prettyValue(oldV) : 'None'} → ${newV ? prettyValue(newV) : 'None'}`
//     // else text = prettyCode(action)
//     // return a?.note ? `${text}\n${a.note}` : text
//     return a?.note
// }

// /** Activity log of one task (newest first). Same ?todoTaskId= param as the other task APIs. */
// export async function loadActivity(taskId: string): Promise<ActivityEntry[]> {
//     try {
//         const response: any = await ApiGetTodoActivity(`?todoTaskId=${taskId}`)
//         return (response?.data ?? [])
//             .map((a: any): ActivityEntry => ({
//                 id: String(a.todoTaskActivityId),
//                 userId: registerUser(a.performedBy), // keeps only id, name and profile picture
//                 type: 'history',
//                 text: activityText(a),
//                 createdAt: toIso(a.performedOn),
//             }))
//             .sort((x: ActivityEntry, y: ActivityEntry) => y.createdAt.localeCompare(x.createdAt))
//     } catch (error) {
//         console.error('Error during API call:', error)
//         return []
//     }
// }

// /** Fetch one task by id (filters the tasks API with todoTaskId), so a save doesn't reload the whole list. */
// export async function loadTask(id: string): Promise<TodoTask | null> {
//     try {
//         const response: any = await ApiGetTodoTasks(`?todoTaskId=${id}`)
//         const found = (response?.data ?? []).find((t: any) => String(t.todoTaskId) === String(id))
//         return found ? mapApiTask(found) : null
//     } catch (error) {
//         console.error('Error during API call:', error)
//         return null
//     }
// }

// // ---------------------------------------------------------------------------
// // Helpers
// // ---------------------------------------------------------------------------

// export const uid = () => Math.random().toString(36).slice(2, 10)

// export const checklistProgress = (task: TodoTask) => ({
//     done: task.checklist.filter((i) => i.isCompleted).length,
//     total: task.checklist.length,
// })

// export const loggedHours = (task: TodoTask) =>
//     Math.round((task.timeSpentMinutes / 60) * 100) / 100

// /** 200 -> "3 h 20 min", 60 -> "1 h", 50 -> "50 min", 0 -> "0 min" */
// export const formatMinutes = (m: number) => {
//     const h = Math.floor(m / 60)
//     const rest = m % 60
//     return h ? (rest ? `${h} h ${rest} min` : `${h} h`) : `${rest} min`
// }

// export const formatDue = (iso: string | null) =>
//     iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }) : 'No date'

// export const formatDueLong = (iso: string | null) =>
//     iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : 'No date'

// /** Exact time in the viewer's own time zone, e.g. "29 Oct, 1:53 pm" (adds the year when it is not this year). */
// export function formatDateTime(iso: string) {
//     if (!iso) return ''
//     const d = new Date(iso)
//     return d.toLocaleString('en-AU', {
//         day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true,
//         ...(d.getFullYear() !== new Date().getFullYear() ? { year: 'numeric' } : {}),
//     })
// }

// export function formatWhen(iso: string) {
//     const then = new Date(iso)
//     const mins = Math.round((Date.now() - then.getTime()) / 60000)
//     if (mins < 1) return 'just now'
//     if (mins < 60) return `${mins} min ago`
//     if (mins < 60 * 24) return `${Math.round(mins / 60)} h ago`
//     return then.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' })
// }

// export function nextTaskKey(tasks: TodoTask[]) {
//     const max = tasks.reduce((m, t) => Math.max(m, Number(t.key.replace(/\D/g, '')) || 0), 0)
//     return `TSK-${max + 1}`
// }


// export function applyPatch(task: TodoTask, patch: TaskPatch, actorId: string = CURRENT_USER_ID): TodoTask {
//     const now = new Date().toISOString()
//     const history: ActivityEntry[] = []
//     const log = (text: string) => history.push({ id: uid(), userId: actorId, type: 'history', text, createdAt: now })

//     if (patch.status && patch.status !== task.status)
//         log(`Changed status from ${STATUS_BY_ID[task.status]?.label ?? task.status} to ${STATUS_BY_ID[patch.status]?.label ?? patch.status}`)
//     if (patch.assigneeId && patch.assigneeId !== task.assigneeId)
//         log(`Reassigned from ${USER_BY_ID[task.assigneeId]?.name ?? 'Unassigned'} to ${USER_BY_ID[patch.assigneeId]?.name ?? 'Unassigned'}`)
//     if (patch.priority && patch.priority !== task.priority)
//         log(`Changed priority from ${PRIORITIES[task.priority].label} to ${PRIORITIES[patch.priority].label}`)

//     return { ...task, ...patch, activity: [...(patch.activity ?? task.activity), ...history], updatedAt: now }
// }

// export function moveTask(
//     tasks: TodoTask[],
//     taskId: string,
//     toStatus: StatusId,
//     beforeId: string | null,
//     actorId: string = CURRENT_USER_ID,
// ): TodoTask[] {
//     const task = tasks.find((t) => t.id === taskId)
//     if (!task) return tasks
//     const rest = tasks.filter((t) => t.id !== taskId)
//     const moved = applyPatch(task, { status: toStatus }, actorId)
//     const at = beforeId ? rest.findIndex((t) => t.id === beforeId) : -1
//     if (at < 0) return [...rest, moved]
//     return [...rest.slice(0, at), moved, ...rest.slice(at)]
// }
// import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp'
// import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown'
// import DragHandleIcon from '@mui/icons-material/DragHandle'
// import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
// import type { SvgIconComponent } from '@mui/icons-material'
// import { ApiGetAdminList, ApiGetTodoStatus, ApiGetTodoTasks, ApiUpdateTodoTasks, ApiUpdateTodoStatus, ApiUpdateTodoChecklist, ApiDeleteTodo, ApiGetTodoActivity } from '../../../apiService/Core/Apicall.tsx'

// export const PRIMARY = '#75724C'

// /** TODO: replace with the logged-in user once this is wired to the API. */
// export const CURRENT_USER_ID = localStorage.getItem('userId') ||""

// /** Lower-cased statusCode from the API: pending, ongoing, on_hold, reassigned, completed, cancelled (deleted is hidden). */
// export type StatusId = string
// export type Priority = 'high' | 'medium' | 'low'

// export interface TodoUser {
//     id: string
//     name: string
//     initials: string
//     color: string
//     profileUrl:string
// }

// export interface ChecklistItem {
//     todoChecklistItemId?: number,
//     itemText: string,
//     isCompleted: boolean,
//     completedOn?: string,
//     displayOrder: number,
//     isActive: boolean,
//     /** User id this item is assigned to. Must be one of the task's assigneeIds. null/undefined = unassigned. */
//     assigneeId?: string | null
// }

// export interface ActivityEntry {
//     id: string
//     userId: string
//     type: 'comment' | 'history'
//     text: string
//     createdAt: string // ISO datetime
// }

// export interface TodoTask {
//     id: string
//     key: string
//     title: string
//     description: string
//     status: StatusId
//     assigneeId: string // main assignee
//     /** Everyone assigned to the task (includes assigneeId). Checklist items can only be assigned to these people. */
//     assigneeIds: string[]
//     reporterId: string
//     priority: Priority
//     labels: string[]
//     dueDate: string | null // ISO yyyy-mm-dd
//     checklist: ChecklistItem[]
//     timeSpentMinutes: number // total time spent, in minutes
//     completionNote: string | null // the single work note
//     activity: ActivityEntry[]
//     createdAt: string
//     updatedAt: string
// }

// /** Fields a screen is allowed to change. History entries are generated by applyPatch. */
// export type TaskPatch = Partial<Omit<TodoTask, 'id' | 'key' | 'reporterId' | 'createdAt' | 'updatedAt'>>

// export interface StatusConfig {
//     id: StatusId
//     apiId: number // todoTaskStatusId, send this to the API
//     label: string
//     dot: string
//     columnBg: string
//     pillBg: string
//     ink: string
// }

// /**
//  * Users come from the admin API. USERS and USER_BY_ID are filled in place by loadUsers(),
//  * so every screen can keep importing them. Call loadUsers() once from the ToDo page
//  * and re-render when it resolves (see ToDo.tsx).
//  */
// export const USERS: TodoUser[] = []
// export const USER_BY_ID: Record<string, TodoUser> = {}

// const AVATAR_COLORS = ['#75724C', '#1976D2', '#2E7D32', '#9C27B0', '#D84315', '#00838F', '#C2185B', '#5E35B1', '#EF6C00', '#455A64']

// // Stable colour per user id (works for numeric and string ids)
// const colorFor = (id: string) => {
//     let h = 0
//     for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0
//     return AVATAR_COLORS[h % AVATAR_COLORS.length]
// }

// const initialsFor = (name: string) =>
//     name.trim().split(/\s+/).map((w) => w[0]).join('').substring(0, 2).toUpperCase() || '?'

// let usersPromise: Promise<TodoUser[]> | null = null

// /** Fetch users once and cache. Pass force = true to refetch. */
// export function loadUsers(force = false): Promise<TodoUser[]> {
//     if (usersPromise && !force) return usersPromise
//     usersPromise = (async () => {
//         try {
//             const response: any = await ApiGetAdminList('?offset=0&limit=1000')
//             const list: TodoUser[] = (response?.data ?? []).map((item: any) => {
//                 const id = String(item?.userId)
//                 const name = item?.displayName || [item?.firstName, item?.lastName].filter(Boolean).join(' ') || 'Unknown User'
//                 return { id, name, initials: initialsFor(name), color: colorFor(id), profileUrl:item?.profilePicUrl}
//             })
//             USERS.splice(0, USERS.length, ...list)
//             Object.keys(USER_BY_ID).forEach((k) => delete USER_BY_ID[k])
//             list.forEach((u) => (USER_BY_ID[u.id] = u))
//         } catch (error) {
//             console.error('Error during API call:', error)
//             usersPromise = null // allow a retry on the next call
//         }
//         return USERS
//     })()
//     return usersPromise
// }

// /** Safe lookup: accepts a number or string id, returns undefined for unassigned or unknown. */
// export const getUserById = (id?: string | number | null) => (id == null || id === '' ? undefined : USER_BY_ID[String(id)])


// // Statuses come from the API (ordered by displayOrder), so nothing here depends on specific
// // codes. STATUSES and STATUS_BY_ID are filled in place by loadStatuses(), same pattern as USERS.
// // The API has no colours: each status takes the next colour set by position, cycling if there are
// // more statuses than sets. If the API later returns a colour, use it in loadStatuses().
// type StatusColors = Pick<StatusConfig, 'dot' | 'columnBg' | 'pillBg' | 'ink'>
// const STATUS_PALETTE: StatusColors[] = [
//     { dot: '#8A8468', columnBg: '#EFEDE3', pillBg: '#E2DFCC', ink: '#55513A' }, // stone
//     { dot: '#3B7DB8', columnBg: '#E7F0F8', pillBg: '#CFE2F2', ink: '#1B4B75' }, // blue
//     { dot: '#C2851A', columnBg: '#FBF1DC', pillBg: '#F3DFAE', ink: '#6E4305' }, // amber
//     { dot: '#7E5BB0', columnBg: '#F0EAF8', pillBg: '#DED0F0', ink: '#43286B' }, // violet
//     { dot: '#2F8F8F', columnBg: '#E3F3F2', pillBg: '#C6E7E5', ink: '#145250' }, // teal
//     { dot: '#B8527A', columnBg: '#F9E9EF', pillBg: '#F1CFDC', ink: '#6B213F' }, // rose
//     { dot: '#B3402F', columnBg: '#FAEAE7', pillBg: '#F3CFC9', ink: '#6E1E13' }, // red
//     { dot: '#3E8D5F', columnBg: '#E4F2E9', pillBg: '#CBE6D5', ink: '#1C5233' }, // green
// ]
// const P = STATUS_PALETTE
// // Known codes get a fixed colour; any new status code the API adds cycles through the palette.
// const COLOR_BY_CODE: Record<string, StatusColors> = {
//     pending: P[0], // stone
//     ongoing: P[1], // blue
//     on_hold: P[2], // amber
//     reassigned: P[3], // violet
//     completed: P[7], // green
//     cancelled: P[6], // red
// }
// const colorsFor = (id: string, index: number): StatusColors => COLOR_BY_CODE[id] ?? P[index % P.length]

// /** Statuses that count as closed (no longer open work). */
// const CLOSED_CODES = ['completed', 'cancelled']
// /** Statuses never shown as board columns / list groups: DELETED is a soft delete, not a workflow step. */
// const HIDDEN_CODES = ['deleted']

// export const STATUSES: StatusConfig[] = []
// export const STATUS_BY_ID: Record<StatusId, StatusConfig> = {}

// let statusesPromise: Promise<StatusConfig[]> | null = null

// /** Fetch statuses once and cache. Pass force = true to refetch. */
// export function loadStatuses(force = false): Promise<StatusConfig[]> {
//     if (statusesPromise && !force) return statusesPromise
//     statusesPromise = (async () => {
//         try {
//             const response: any = await ApiGetTodoStatus()
//             const list: StatusConfig[] = (response?.data ?? [])
//                 .filter((item: any) => item?.isActive !== false && !HIDDEN_CODES.includes(String(item?.statusCode ?? '').toLowerCase()))
//                 .sort((a: any, b: any) => (a?.displayOrder ?? 0) - (b?.displayOrder ?? 0))
//                 .map((item: any, index: number) => {
//                     const id = String(item?.statusCode ?? '').toLowerCase()
//                     return {
//                         id,
//                         apiId: Number(item?.todoTaskStatusId),
//                         label: item?.statusName ?? id,
//                         ...colorsFor(id, index),
//                     }
//                 })
//             STATUSES.splice(0, STATUSES.length, ...list)
//             Object.keys(STATUS_BY_ID).forEach((k) => delete STATUS_BY_ID[k])
//             list.forEach((st) => (STATUS_BY_ID[st.id] = st))
//         } catch (error) {
//             console.error('Error during API call:', error)
//             statusesPromise = null // allow a retry on the next call
//         }
//         return STATUSES
//     })()
//     return statusesPromise
// }

// /** True for statuses that mean the work is closed (completed or cancelled). */
// export const isFinalStatus = (id: StatusId) => CLOSED_CODES.includes(id)

// /** Default status for new tasks: the first one in display order. */
// export const defaultStatusId = (): StatusId => STATUSES[0]?.id ?? 'pending'

// export const PRIORITIES: Record<Priority, { label: string; color: string; Icon: SvgIconComponent }> = {
//     high: { label: 'High', color: '#B3402F', Icon: KeyboardDoubleArrowUpIcon },
//     medium: { label: 'Medium', color: '#8A5E0E', Icon: DragHandleIcon },
//     low: { label: 'Low', color: '#2F6E9F', Icon: KeyboardDoubleArrowDownIcon },
// }



// // ---------------------------------------------------------------------------
// // Tasks from the API
// // ---------------------------------------------------------------------------

// /**
//  * The server stores Australian local time ("2026-10-29 18:53:57" = Sydney/Melbourne time, +11:00 in daylight saving).
//  * Change this if the server runs in another zone (Australia/Perth, Australia/Sydney ...).
//  */
// export const SERVER_TIME_ZONE = 'Australia/Sydney'

// /** Offset (ms) of a time zone from UTC at the given instant, DST included. */
// function zoneOffsetMs(timeZone: string, at: number): number {
//     const parts = new Intl.DateTimeFormat('en-US', {
//         timeZone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
//     }).formatToParts(new Date(at))
//     const n = (t: string) => Number(parts.find((p) => p.type === t)?.value)
//     return Date.UTC(n('year'), n('month') - 1, n('day'), n('hour'), n('minute'), n('second')) - Math.floor(at / 1000) * 1000
// }

// /**
//  * "2026-10-29 18:53:57" (server time in SERVER_TIME_ZONE) -> real UTC ISO string.
//  * Dates then render in each user's own time zone via new Date(iso) / toLocale*String.
//  */
// const toIso = (v?: string | null) => {
//     if (!v) return ''
//     const m = v.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/)
//     if (!m) return ''
//     const wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] ?? 0))
//     let t = wall - zoneOffsetMs(SERVER_TIME_ZONE, wall)
//     t = wall - zoneOffsetMs(SERVER_TIME_ZONE, t) // second pass settles DST edges
//     return new Date(t).toISOString()
// }

// /**
//  * Users embedded in a task (assignedTo / assignedBy) may not be in the admin list.
//  * Register just id + name so lookups and selects work. Nothing else from the embedded
//  * user object is kept (it carries sensitive fields).
//  */
// function registerUser(u: any): string {
//     if (!u?.userId) return ''
//     const id = String(u.userId)
//     if (!USER_BY_ID[id]) {
//         const name = u.displayName || [u.firstName, u.lastName].filter(Boolean).join(' ') || 'Unknown User'
//         const user: TodoUser = { id, name, initials: initialsFor(name), color: colorFor(id), profileUrl:u.profilePicUrl}
//         USER_BY_ID[id] = user
//         USERS.push(user)
//     }
//     return id
// }

// /** One checklist item from the API. assignedTo may arrive as a user object or a plain id. */
// function mapChecklistItem(c: any): ChecklistItem {
//     const a = c?.assignedTo
//     const assigneeId = a && typeof a === 'object' ? registerUser(a) : a != null && a !== '' ? String(a) : ''
//     return {
//         todoChecklistItemId: c.todoChecklistItemId,
//         itemText: c.itemText ?? '',
//         isCompleted: !!c.isCompleted,
//         completedOn: c.completedOn ?? undefined,
//         displayOrder: Number(c.displayOrder) || 0,
//         isActive: c.isActive !== false,
//         assigneeId: assigneeId || null,
//     }
// }

// /** Map one API task to the shape the screens use. */
// export function mapApiTask(t: any): TodoTask {
//     const reporterId = registerUser(t.assignedBy)
//     // API shape: assignees: [{ isPrimary, userId: { ...user } }]. A task-level assignedTo is also accepted if it ever comes back.
//     const people = (Array.isArray(t.assignees) ? t.assignees : [])
//         .map((r: any) => ({ id: registerUser(r?.userId && typeof r.userId === 'object' ? r.userId : r), primary: !!r?.isPrimary }))
//         .filter((p: { id: string }) => p.id)
//     // main assignee: the primary one, else assignedTo, else the first person on the task
//     const assigneeId: string = people.find((p: { primary: boolean }) => p.primary)?.id || registerUser(t.assignedTo) || people[0]?.id || ''
//     const assigneeIds: string[] = Array.from(new Set([assigneeId, ...people.map((p: { id: string }) => p.id)].filter(Boolean)))
//     const priority = String(t.priority ?? 'medium').toLowerCase() as Priority
//     return {
//         id: String(t.todoTaskId),
//         key: `TSK-${t.todoTaskId}`,
//         title: t.title ?? '',
//         description: t.description ?? '',
//         status: String(t.todoTaskStatusId?.statusCode ?? '').toLowerCase(),
//         assigneeId,
//         assigneeIds,
//         reporterId,
//         priority: PRIORITIES[priority] ? priority : 'medium',
//         labels: [], // not in the list API yet
//         dueDate: t.dueDate ? String(t.dueDate).slice(0, 10) : null,
//         checklist: (t.checklistItems ?? []).filter((c: any) => c?.isActive).map(mapChecklistItem),
//         completionNote: t.completionNote ?? null,
//         timeSpentMinutes: Number(t.timeSpentMinutes) || 0,
//         activity: [], // needs the activity API
//         createdAt: toIso(t.createdOn),
//         updatedAt: toIso(t.modifiedOn || t.createdOn),
//     }
// }

// /** Fetch tasks. Query string format follows ApiGetAdminList; adjust if ApiGetTodoTasks differs. */
// export async function loadTasks(query = '?page=1&limit=1000'): Promise<TodoTask[]> {
//     try {
//         const response: any = await ApiGetTodoTasks(query)
//         return (response?.data ?? []).map(mapApiTask)
//     } catch (error) {
//         console.error('Error during API call:', error)
//         return []
//     }
// }

// // ---------------------------------------------------------------------------
// // Saving: each kind of change has its own API. All of them take ?todoTaskId=<id> as params.
// // ---------------------------------------------------------------------------

// /** Patch keys handled by ApiUpdateTodoTasks. */
// export const DETAIL_KEYS: (keyof TaskPatch)[] = ['title', 'description', 'priority']
// /** Patch keys handled by ApiUpdateTodoStatus (status, reassign, due date, time spent and note). */
// export const STATUS_KEYS: (keyof TaskPatch)[] = ['status', 'assigneeId', 'assigneeIds', 'dueDate', 'timeSpentMinutes', 'completionNote']
// /** Patch key handled by ApiUpdateTodoChecklist. */
// export const CHECKLIST_KEY: keyof TaskPatch = 'checklist'

// const idParam = (task: TodoTask) => `?todoTaskId=${task.id}`

// /** Throw when the server answers with status:false, so callers can roll back. */
// const ensureOk = (response: any) => {
//     if (response?.status === false) throw new Error(response?.message || 'Request failed')
//     return response
// }

// /** 'on_hold' -> 'ON_HOLD' (the API's todoTaskStatusCode) */
// export const statusCodeOf = (id: StatusId) => id.toUpperCase()

// /** Title, description and priority. */
// export async function saveTaskDetails(task: TodoTask) {
//     return ensureOk(
//         await ApiUpdateTodoTasks(idParam(task), {
//             title: task.title,
//             description: task.description,
//             priority: task.priority.toUpperCase(), // URGENT | HIGH | MEDIUM | LOW
//         }),
//     )
// }

// /** True when the set of people on the task differs (order ignored). */
// export const assigneesChanged = (a: TodoTask, b: TodoTask) =>
//     [...a.assigneeIds].sort().join(',') !== [...b.assigneeIds].sort().join(',')

// /**
//  * Status, due date, time spent + note, and the people on the task.
//  * assignedTo is an array of user ids, main assignee first. It is sent when the assignees changed
//  * (assigneesChanged = true) or when the status is REASSIGNED, never on a plain status/date/work-log save.
//  * timeSpent and completionNote go together.
//  */
// export async function saveTaskStatus(task: TodoTask, assigneesChanged = false) {
//     const hasWork = task.timeSpentMinutes > 0 || !!task.completionNote
//     const sendAssignees = (assigneesChanged || task.status === 'reassigned') && task.assigneeIds.length > 0
//     return ensureOk(
//         await ApiUpdateTodoStatus(idParam(task), {
//             todoTaskStatusCode: statusCodeOf(task.status),
//             ...(hasWork ? { completionNote: task.completionNote ?? '', timeSpent: task.timeSpentMinutes } : {}),
//             ...(task.dueDate ? { dueDate: task.dueDate } : {}), // yyyy-mm-dd only
//             ...(sendAssignees ? { assignedTo: task.assigneeIds.map(Number) } : {}),
//         }),
//     )
// }

// /**
//  * Checklist: compares before/after and sends only what changed, one small request per change
//  * (all to ApiUpdateTodoChecklist with ?todoTaskId=):
//  *   add       { itemText, isCompleted, displayOrder, isActive: true, assignedTo? }
//  *   tick      { todoChecklistItemId, isCompleted }
//  *   delete    { todoChecklistItemId, isActive: false }
//  *   assign    { todoChecklistItemId, assignedTo: <userId> }
//  *   unassign  { todoChecklistItemId, assignedTo: null }
//  * Requests run one after another and stop at the first failure.
//  */
// export async function saveTaskChecklist(before: TodoTask, after: TodoTask) {
//     const params = idParam(after)
//     const beforeById = new Map(before.checklist.filter((c) => c.todoChecklistItemId).map((c) => [c.todoChecklistItemId, c] as const))
//     const afterIds = new Set(after.checklist.map((c) => c.todoChecklistItemId).filter(Boolean))
//     const bodies: Record<string, unknown>[] = []

//     // removed
//     before.checklist.forEach((c) => {
//         if (c.todoChecklistItemId && !afterIds.has(c.todoChecklistItemId)) bodies.push({ todoChecklistItemId: c.todoChecklistItemId, isActive: false })
//     })
//     // ticked / assigned
//     after.checklist.forEach((c) => {
//         const old = c.todoChecklistItemId ? beforeById.get(c.todoChecklistItemId) : undefined
//         if (!old) return
//         if (old.isCompleted !== c.isCompleted) bodies.push({ todoChecklistItemId: c.todoChecklistItemId, isCompleted: c.isCompleted })
//         if ((old.assigneeId ?? null) !== (c.assigneeId ?? null)) bodies.push({ todoChecklistItemId: c.todoChecklistItemId, assignedTo: c.assigneeId ? Number(c.assigneeId) : null })
//     })
//     // added (no id yet): continue after the highest existing order, so removed items can't clash
//     let order = Math.max(0, ...before.checklist.map((c) => c.displayOrder))
//     after.checklist.forEach((c) => {
//         if (!c.todoChecklistItemId) bodies.push({ itemText: c.itemText, isCompleted: c.isCompleted, displayOrder: ++order, isActive: true, ...(c.assigneeId ? { assignedTo: Number(c.assigneeId) } : {}) })
//     })

//     let last: any
//     for (const body of bodies) last = ensureOk(await ApiUpdateTodoChecklist(params, body))
//     return last
// }

// export async function deleteTodoTask(task: TodoTask) {
//     return ensureOk(await ApiDeleteTodo(idParam(task)))
// }

// const prettyCode = (code: string) =>
//     code.toLowerCase().split('_').filter(Boolean).map((w) => w[0].toUpperCase() + w.slice(1)).join(' ')

// /** 'PENDING' -> 'Pending' using the loaded status labels, anything else -> 'Some Value'. */
// const prettyValue = (v: string) => STATUS_BY_ID[v.toLowerCase()]?.label ?? (PRIORITIES[v.toLowerCase() as Priority]?.label ?? prettyCode(v))

// /**
//  * One sentence per activity row. The API sends { action, oldValue, newValue, note }.
//  * When the action is a status code (ONGOING, ON_HOLD ...) it reads as a status change;
//  * for any other action it falls back to "<Action>: old -> new", so new action types still show up.
//  */
// function activityText(a: any): string {
//     // const action = String(a?.action ?? '')
//     // const oldV = a?.oldValue ? String(a.oldValue) : ''
//     // const newV = a?.newValue ? String(a.newValue) : ''
//     // const isStatus = !!STATUS_BY_ID[action.toLowerCase()]
//     // let text: string
//     // if (isStatus) text = oldV ? `Changed status from ${prettyValue(oldV)} to ${prettyValue(newV || action)}` : `Set status to ${prettyValue(newV || action)}`
//     // else if (oldV || newV) text = `${prettyCode(action)}: ${oldV ? prettyValue(oldV) : 'None'} → ${newV ? prettyValue(newV) : 'None'}`
//     // else text = prettyCode(action)
//     // return a?.note ? `${text}\n${a.note}` : text
//     return a?.note
// }

// /** Activity log of one task (newest first). Same ?todoTaskId= param as the other task APIs. */
// export async function loadActivity(taskId: string): Promise<ActivityEntry[]> {
//     try {
//         const response: any = await ApiGetTodoActivity(`?todoTaskId=${taskId}`)
//         return (response?.data ?? [])
//             .map((a: any): ActivityEntry => ({
//                 id: String(a.todoTaskActivityId),
//                 userId: registerUser(a.performedBy), // keeps only id, name and profile picture
//                 type: 'history',
//                 text: activityText(a),
//                 createdAt: toIso(a.performedOn),
//             }))
//             .sort((x: ActivityEntry, y: ActivityEntry) => y.createdAt.localeCompare(x.createdAt))
//     } catch (error) {
//         console.error('Error during API call:', error)
//         return []
//     }
// }

// /** Fetch one task by id (filters the tasks API with todoTaskId), so a save doesn't reload the whole list. */
// export async function loadTask(id: string): Promise<TodoTask | null> {
//     try {
//         const response: any = await ApiGetTodoTasks(`?todoTaskId=${id}`)
//         const found = (response?.data ?? []).find((t: any) => String(t.todoTaskId) === String(id))
//         return found ? mapApiTask(found) : null
//     } catch (error) {
//         console.error('Error during API call:', error)
//         return null
//     }
// }

// // ---------------------------------------------------------------------------
// // Helpers
// // ---------------------------------------------------------------------------

// export const uid = () => Math.random().toString(36).slice(2, 10)

// export const checklistProgress = (task: TodoTask) => ({
//     done: task.checklist.filter((i) => i.isCompleted).length,
//     total: task.checklist.length,
// })

// export const loggedHours = (task: TodoTask) =>
//     Math.round((task.timeSpentMinutes / 60) * 100) / 100

// /** 200 -> "3 h 20 min", 60 -> "1 h", 50 -> "50 min", 0 -> "0 min" */
// export const formatMinutes = (m: number) => {
//     const h = Math.floor(m / 60)
//     const rest = m % 60
//     return h ? (rest ? `${h} h ${rest} min` : `${h} h`) : `${rest} min`
// }

// export const formatDue = (iso: string | null) =>
//     iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }) : 'No date'

// export const formatDueLong = (iso: string | null) =>
//     iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : 'No date'

// /** Exact time in the viewer's own time zone, e.g. "29 Oct, 1:53 pm" (adds the year when it is not this year). */
// export function formatDateTime(iso: string) {
//     if (!iso) return ''
//     const d = new Date(iso)
//     return d.toLocaleString('en-AU', {
//         day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true,
//         ...(d.getFullYear() !== new Date().getFullYear() ? { year: 'numeric' } : {}),
//     })
// }

// export function formatWhen(iso: string) {
//     const then = new Date(iso)
//     const mins = Math.round((Date.now() - then.getTime()) / 60000)
//     if (mins < 1) return 'just now'
//     if (mins < 60) return `${mins} min ago`
//     if (mins < 60 * 24) return `${Math.round(mins / 60)} h ago`
//     return then.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' })
// }

// export function nextTaskKey(tasks: TodoTask[]) {
//     const max = tasks.reduce((m, t) => Math.max(m, Number(t.key.replace(/\D/g, '')) || 0), 0)
//     return `TSK-${max + 1}`
// }


// export function applyPatch(task: TodoTask, rawPatch: TaskPatch, actorId: string = CURRENT_USER_ID): TodoTask {
//     // assigneeIds (list, main first) and assigneeId (main) always move together; a lone assigneeId means "only this person"
//     let patch = rawPatch
//     if (patch.assigneeIds?.length) patch = { ...patch, assigneeId: patch.assigneeIds[0] }
//     else if (patch.assigneeId && !patch.assigneeIds) patch = { ...patch, assigneeIds: [patch.assigneeId] }
//     const now = new Date().toISOString()
//     const history: ActivityEntry[] = []
//     const log = (text: string) => history.push({ id: uid(), userId: actorId, type: 'history', text, createdAt: now })

//     if (patch.status && patch.status !== task.status)
//         log(`Changed status from ${STATUS_BY_ID[task.status]?.label ?? task.status} to ${STATUS_BY_ID[patch.status]?.label ?? patch.status}`)
//     if (patch.assigneeId && patch.assigneeId !== task.assigneeId)
//         log(`Reassigned from ${USER_BY_ID[task.assigneeId]?.name ?? 'Unassigned'} to ${USER_BY_ID[patch.assigneeId]?.name ?? 'Unassigned'}`)
//     if (patch.priority && patch.priority !== task.priority)
//         log(`Changed priority from ${PRIORITIES[task.priority].label} to ${PRIORITIES[patch.priority].label}`)

//     return { ...task, ...patch, activity: [...(patch.activity ?? task.activity), ...history], updatedAt: now }
// }

// export function moveTask(
//     tasks: TodoTask[],
//     taskId: string,
//     toStatus: StatusId,
//     beforeId: string | null,
//     actorId: string = CURRENT_USER_ID,
// ): TodoTask[] {
//     const task = tasks.find((t) => t.id === taskId)
//     if (!task) return tasks
//     const rest = tasks.filter((t) => t.id !== taskId)
//     const moved = applyPatch(task, { status: toStatus }, actorId)
//     const at = beforeId ? rest.findIndex((t) => t.id === beforeId) : -1
//     if (at < 0) return [...rest, moved]
//     return [...rest.slice(0, at), moved, ...rest.slice(at)]
// }

import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown'
import DragHandleIcon from '@mui/icons-material/DragHandle'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
import type { SvgIconComponent } from '@mui/icons-material'
import { ApiGetAdminList, ApiGetTodoStatus, ApiGetTodoTasks, ApiUpdateTodoTasks, ApiUpdateTodoStatus, ApiUpdateTodoChecklist, ApiDeleteTodo, ApiGetTodoActivity } from '../../../apiService/Core/Apicall.tsx'

export const PRIMARY = '#75724C'

/** TODO: replace with the logged-in user once this is wired to the API. */
export const CURRENT_USER_ID = localStorage.getItem('userId') ||""

/** Lower-cased statusCode from the API: pending, ongoing, on_hold, reassigned, completed, cancelled (deleted is hidden). */
export type StatusId = string
export type Priority = 'high' | 'medium' | 'low'

export interface TodoUser {
    id: string
    name: string
    initials: string
    color: string
    profileUrl:string
}

export interface ChecklistItem {
    todoChecklistItemId?: number,
    itemText: string,
    isCompleted: boolean,
    completedOn?: string,
    displayOrder: number,
    isActive: boolean,
    /** User id this item is assigned to. Must be one of the task's assigneeIds. null/undefined = unassigned. */
    assigneeId?: string | null
}

export interface ActivityEntry {
    id: string
    userId: string
    type: 'comment' | 'history'
    text: string
    createdAt: string // ISO datetime
}

export interface TodoTask {
    id: string
    key: string
    title: string
    description: string
    status: StatusId
    assigneeId: string // main assignee
    /** Everyone assigned to the task (includes assigneeId). Checklist items can only be assigned to these people. */
    assigneeIds: string[]
    reporterId: string
    priority: Priority
    labels: string[]
    dueDate: string | null // ISO yyyy-mm-dd
    checklist: ChecklistItem[]
    timeSpentMinutes: number // total time spent, in minutes
    completionNote: string | null // the single work note
    activity: ActivityEntry[]
    createdAt: string
    updatedAt: string
}

/** Fields a screen is allowed to change. History entries are generated by applyPatch. */
export type TaskPatch = Partial<Omit<TodoTask, 'id' | 'key' | 'reporterId' | 'createdAt' | 'updatedAt'>>

export interface StatusConfig {
    id: StatusId
    apiId: number // todoTaskStatusId, send this to the API
    label: string
    dot: string
    columnBg: string
    pillBg: string
    ink: string
}

/**
 * Users come from the admin API. USERS and USER_BY_ID are filled in place by loadUsers(),
 * so every screen can keep importing them. Call loadUsers() once from the ToDo page
 * and re-render when it resolves (see ToDo.tsx).
 */
export const USERS: TodoUser[] = []
export const USER_BY_ID: Record<string, TodoUser> = {}

const AVATAR_COLORS = ['#75724C', '#1976D2', '#2E7D32', '#9C27B0', '#D84315', '#00838F', '#C2185B', '#5E35B1', '#EF6C00', '#455A64']

// Stable colour per user id (works for numeric and string ids)
const colorFor = (id: string) => {
    let h = 0
    for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0
    return AVATAR_COLORS[h % AVATAR_COLORS.length]
}

const initialsFor = (name: string) =>
    name.trim().split(/\s+/).map((w) => w[0]).join('').substring(0, 2).toUpperCase() || '?'

let usersPromise: Promise<TodoUser[]> | null = null

/** Fetch users once and cache. Pass force = true to refetch. */
export function loadUsers(force = false): Promise<TodoUser[]> {
    if (usersPromise && !force) return usersPromise
    usersPromise = (async () => {
        try {
            const response: any = await ApiGetAdminList('?offset=0&limit=1000')
            const list: TodoUser[] = (response?.data ?? []).map((item: any) => {
                const id = String(item?.userId)
                const name = item?.displayName || [item?.firstName, item?.lastName].filter(Boolean).join(' ') || 'Unknown User'
                return { id, name, initials: initialsFor(name), color: colorFor(id), profileUrl:item?.profilePicUrl}
            })
            console.log("Users ", list)
            USERS.splice(0, USERS.length, ...list)
            Object.keys(USER_BY_ID).forEach((k) => delete USER_BY_ID[k])
            list.forEach((u) => (USER_BY_ID[u.id] = u))
        } catch (error) {
            console.error('Error during API call:', error)
            usersPromise = null // allow a retry on the next call
        }
        return USERS
    })()
    return usersPromise
}

/** Safe lookup: accepts a number or string id, returns undefined for unassigned or unknown. */
export const getUserById = (id?: string | number | null) => (id == null || id === '' ? undefined : USER_BY_ID[String(id)])


// Statuses come from the API (ordered by displayOrder), so nothing here depends on specific
// codes. STATUSES and STATUS_BY_ID are filled in place by loadStatuses(), same pattern as USERS.
// The API has no colours: each status takes the next colour set by position, cycling if there are
// more statuses than sets. If the API later returns a colour, use it in loadStatuses().
type StatusColors = Pick<StatusConfig, 'dot' | 'columnBg' | 'pillBg' | 'ink'>
const STATUS_PALETTE: StatusColors[] = [
    { dot: '#8A8468', columnBg: '#EFEDE3', pillBg: '#E2DFCC', ink: '#55513A' }, // stone
    { dot: '#3B7DB8', columnBg: '#E7F0F8', pillBg: '#CFE2F2', ink: '#1B4B75' }, // blue
    { dot: '#C2851A', columnBg: '#FBF1DC', pillBg: '#F3DFAE', ink: '#6E4305' }, // amber
    { dot: '#7E5BB0', columnBg: '#F0EAF8', pillBg: '#DED0F0', ink: '#43286B' }, // violet
    { dot: '#2F8F8F', columnBg: '#E3F3F2', pillBg: '#C6E7E5', ink: '#145250' }, // teal
    { dot: '#B8527A', columnBg: '#F9E9EF', pillBg: '#F1CFDC', ink: '#6B213F' }, // rose
    { dot: '#B3402F', columnBg: '#FAEAE7', pillBg: '#F3CFC9', ink: '#6E1E13' }, // red
    { dot: '#3E8D5F', columnBg: '#E4F2E9', pillBg: '#CBE6D5', ink: '#1C5233' }, // green
]
const P = STATUS_PALETTE
// Known codes get a fixed colour; any new status code the API adds cycles through the palette.
const COLOR_BY_CODE: Record<string, StatusColors> = {
    pending: P[0], // stone
    ongoing: P[1], // blue
    on_hold: P[2], // amber
    reassigned: P[3], // violet
    completed: P[7], // green
    cancelled: P[6], // red
}
const colorsFor = (id: string, index: number): StatusColors => COLOR_BY_CODE[id] ?? P[index % P.length]

/** Statuses that count as closed (no longer open work). */
const CLOSED_CODES = ['completed', 'cancelled']
/** Statuses never shown as board columns / list groups: DELETED is a soft delete, not a workflow step. */
const HIDDEN_CODES = ['deleted']

export const STATUSES: StatusConfig[] = []
export const STATUS_BY_ID: Record<StatusId, StatusConfig> = {}

let statusesPromise: Promise<StatusConfig[]> | null = null

/** Fetch statuses once and cache. Pass force = true to refetch. */
export function loadStatuses(force = false): Promise<StatusConfig[]> {
    if (statusesPromise && !force) return statusesPromise
    statusesPromise = (async () => {
        try {
            const response: any = await ApiGetTodoStatus()
            const list: StatusConfig[] = (response?.data ?? [])
                .filter((item: any) => item?.isActive !== false && !HIDDEN_CODES.includes(String(item?.statusCode ?? '').toLowerCase()))
                .sort((a: any, b: any) => (a?.displayOrder ?? 0) - (b?.displayOrder ?? 0))
                .map((item: any, index: number) => {
                    const id = String(item?.statusCode ?? '').toLowerCase()
                    return {
                        id,
                        apiId: Number(item?.todoTaskStatusId),
                        label: item?.statusName ?? id,
                        ...colorsFor(id, index),
                    }
                })
            STATUSES.splice(0, STATUSES.length, ...list)
            Object.keys(STATUS_BY_ID).forEach((k) => delete STATUS_BY_ID[k])
            list.forEach((st) => (STATUS_BY_ID[st.id] = st))
        } catch (error) {
            console.error('Error during API call:', error)
            statusesPromise = null // allow a retry on the next call
        }
        return STATUSES
    })()
    return statusesPromise
}

/** True for statuses that mean the work is closed (completed or cancelled). */
export const isFinalStatus = (id: StatusId) => CLOSED_CODES.includes(id)

/** Default status for new tasks: the first one in display order. */
export const defaultStatusId = (): StatusId => STATUSES[0]?.id ?? 'pending'

export const PRIORITIES: Record<Priority, { label: string; color: string; Icon: SvgIconComponent }> = {
    high: { label: 'High', color: '#B3402F', Icon: KeyboardDoubleArrowUpIcon },
    medium: { label: 'Medium', color: '#8A5E0E', Icon: DragHandleIcon },
    low: { label: 'Low', color: '#2F6E9F', Icon: KeyboardDoubleArrowDownIcon },
}



// ---------------------------------------------------------------------------
// Tasks from the API
// ---------------------------------------------------------------------------

/**
 * The server stores Australian local time ("2026-10-29 18:53:57" = Sydney/Melbourne time, +11:00 in daylight saving).
 * Change this if the server runs in another zone (Australia/Perth, Australia/Sydney ...).
 */
export const SERVER_TIME_ZONE = 'Australia/Sydney'

/** Offset (ms) of a time zone from UTC at the given instant, DST included. */
function zoneOffsetMs(timeZone: string, at: number): number {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
    }).formatToParts(new Date(at))
    const n = (t: string) => Number(parts.find((p) => p.type === t)?.value)
    return Date.UTC(n('year'), n('month') - 1, n('day'), n('hour'), n('minute'), n('second')) - Math.floor(at / 1000) * 1000
}

/**
 * "2026-10-29 18:53:57" (server time in SERVER_TIME_ZONE) -> real UTC ISO string.
 * Dates then render in each user's own time zone via new Date(iso) / toLocale*String.
 */
const toIso = (v?: string | null) => {
    if (!v) return ''
    const m = v.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/)
    if (!m) return ''
    const wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] ?? 0))
    let t = wall - zoneOffsetMs(SERVER_TIME_ZONE, wall)
    t = wall - zoneOffsetMs(SERVER_TIME_ZONE, t) // second pass settles DST edges
    return new Date(t).toISOString()
}

/**
 * Users come ONLY from the admin list (loadUsers). Task, checklist and activity rows just point at them:
 * this returns the user id if that person is in the admin list, otherwise '' (nobody new is ever created).
 */
function knownUserId(u: any): string {
    const id = u?.userId != null ? String(u.userId) : ''
    return id && USER_BY_ID[id] ? id : ''
}

/** One checklist item from the API. assignedTo may arrive as a user object or a plain id. */
function mapChecklistItem(c: any): ChecklistItem {
    const a = c?.assignedTo
    const assigneeId = knownUserId(a && typeof a === 'object' ? a : { userId: a })
    return {
        todoChecklistItemId: c.todoChecklistItemId,
        itemText: c.itemText ?? '',
        isCompleted: !!c.isCompleted,
        completedOn: c.completedOn ?? undefined,
        displayOrder: Number(c.displayOrder) || 0,
        isActive: c.isActive !== false,
        assigneeId: assigneeId || null,
    }
}

/** Map one API task to the shape the screens use. */
export function mapApiTask(t: any): TodoTask {
    const reporterId = knownUserId(t.assignedBy)
    // API shape: assignees: [{ isPrimary, userId: { ...user } }]. A task-level assignedTo is also accepted if it ever comes back.
    const people = (Array.isArray(t.assignees) ? t.assignees : [])
        .map((r: any) => ({ id: knownUserId(r?.userId && typeof r.userId === 'object' ? r.userId : r), primary: !!r?.isPrimary }))
        .filter((p: { id: string }) => p.id)
    // main assignee: the primary one, else assignedTo, else the first person on the task
    const assigneeId: string = people.find((p: { primary: boolean }) => p.primary)?.id || knownUserId(t.assignedTo) || people[0]?.id || ''
    const assigneeIds: string[] = Array.from(new Set([assigneeId, ...people.map((p: { id: string }) => p.id)].filter(Boolean)))
    const priority = String(t.priority ?? 'medium').toLowerCase() as Priority
    return {
        id: String(t.todoTaskId),
        key: `TSK-${t.todoTaskId}`,
        title: t.title ?? '',
        description: t.description ?? '',
        status: String(t.todoTaskStatusId?.statusCode ?? '').toLowerCase(),
        assigneeId,
        assigneeIds,
        reporterId,
        priority: PRIORITIES[priority] ? priority : 'medium',
        labels: [], // not in the list API yet
        dueDate: t.dueDate ? String(t.dueDate).slice(0, 10) : null,
        checklist: (t.checklistItems ?? []).filter((c: any) => c?.isActive).map(mapChecklistItem),
        completionNote: t.completionNote ?? null,
        timeSpentMinutes: Number(t.timeSpentMinutes) || 0,
        activity: [], // needs the activity API
        createdAt: toIso(t.createdOn),
        updatedAt: toIso(t.modifiedOn || t.createdOn),
    }
}

/** Fetch tasks. Query string format follows ApiGetAdminList; adjust if ApiGetTodoTasks differs. */
export async function loadTasks(query = '?page=1&limit=1000'): Promise<TodoTask[]> {
    try {
        const response: any = await ApiGetTodoTasks(query)
        return (response?.data ?? []).map(mapApiTask)
    } catch (error) {
        console.error('Error during API call:', error)
        return []
    }
}

// ---------------------------------------------------------------------------
// Saving: each kind of change has its own API. All of them take ?todoTaskId=<id> as params.
// ---------------------------------------------------------------------------

/** Patch keys handled by ApiUpdateTodoTasks. */
export const DETAIL_KEYS: (keyof TaskPatch)[] = ['title', 'description', 'priority']
/** Patch keys handled by ApiUpdateTodoStatus (status, reassign, due date, time spent and note). */
export const STATUS_KEYS: (keyof TaskPatch)[] = ['status', 'assigneeId', 'assigneeIds', 'dueDate', 'timeSpentMinutes', 'completionNote']
/** Patch key handled by ApiUpdateTodoChecklist. */
export const CHECKLIST_KEY: keyof TaskPatch = 'checklist'

const idParam = (task: TodoTask) => `?todoTaskId=${task.id}`

/** Throw when the server answers with status:false, so callers can roll back. */
const ensureOk = (response: any) => {
    if (response?.status === false) throw new Error(response?.message || 'Request failed')
    return response
}

/** 'on_hold' -> 'ON_HOLD' (the API's todoTaskStatusCode) */
export const statusCodeOf = (id: StatusId) => id.toUpperCase()

/** Title, description and priority. */
export async function saveTaskDetails(task: TodoTask) {
    return ensureOk(
        await ApiUpdateTodoTasks(idParam(task), {
            title: task.title,
            description: task.description,
            priority: task.priority.toUpperCase(), // URGENT | HIGH | MEDIUM | LOW
        }),
    )
}

/** True when the set of people on the task differs (order ignored). */
export const assigneesChanged = (a: TodoTask, b: TodoTask) =>
    [...a.assigneeIds].sort().join(',') !== [...b.assigneeIds].sort().join(',')

/**
 * Status, due date, time spent + note, and the people on the task.
 * assignedTo is an array of user ids, main assignee first. It is sent when the assignees changed
 * (assigneesChanged = true) or when the status is REASSIGNED, never on a plain status/date/work-log save.
 * timeSpent and completionNote go together.
 */
export async function saveTaskStatus(task: TodoTask, assigneesChanged = false) {
    const hasWork = task.timeSpentMinutes > 0 || !!task.completionNote
    const sendAssignees = (assigneesChanged || task.status === 'reassigned') && task.assigneeIds.length > 0
    return ensureOk(
        await ApiUpdateTodoStatus(idParam(task), {
            todoTaskStatusCode: statusCodeOf(task.status),
            ...(hasWork ? { completionNote: task.completionNote ?? '', timeSpent: task.timeSpentMinutes } : {}),
            ...(task.dueDate ? { dueDate: task.dueDate } : {}), // yyyy-mm-dd only
            ...(sendAssignees ? { assignedTo: task.assigneeIds.map(Number) } : {}),
        }),
    )
}

/**
 * Checklist: compares before/after and sends only what changed, one small request per change
 * (all to ApiUpdateTodoChecklist with ?todoTaskId=):
 *   add       { itemText, isCompleted, displayOrder, isActive: true, assignedTo? }
 *   tick      { todoChecklistItemId, isCompleted }
 *   delete    { todoChecklistItemId, isActive: false }
 *   assign    { todoChecklistItemId, assignedTo: <userId> }
 *   unassign  { todoChecklistItemId, assignedTo: null }
 * Requests run one after another and stop at the first failure.
 */
export async function saveTaskChecklist(before: TodoTask, after: TodoTask) {
    const params = idParam(after)
    const beforeById = new Map(before.checklist.filter((c) => c.todoChecklistItemId).map((c) => [c.todoChecklistItemId, c] as const))
    const afterIds = new Set(after.checklist.map((c) => c.todoChecklistItemId).filter(Boolean))
    const bodies: Record<string, unknown>[] = []

    // removed
    before.checklist.forEach((c) => {
        if (c.todoChecklistItemId && !afterIds.has(c.todoChecklistItemId)) bodies.push({ todoChecklistItemId: c.todoChecklistItemId, isActive: false })
    })
    // ticked / assigned
    after.checklist.forEach((c) => {
        const old = c.todoChecklistItemId ? beforeById.get(c.todoChecklistItemId) : undefined
        if (!old) return
        if (old.isCompleted !== c.isCompleted) bodies.push({ todoChecklistItemId: c.todoChecklistItemId, isCompleted: c.isCompleted })
        if ((old.assigneeId ?? null) !== (c.assigneeId ?? null)) bodies.push({ todoChecklistItemId: c.todoChecklistItemId, assignedTo: c.assigneeId ? Number(c.assigneeId) : null })
    })
    // added (no id yet): continue after the highest existing order, so removed items can't clash
    let order = Math.max(0, ...before.checklist.map((c) => c.displayOrder))
    after.checklist.forEach((c) => {
        if (!c.todoChecklistItemId) bodies.push({ itemText: c.itemText, isCompleted: c.isCompleted, displayOrder: ++order, isActive: true, ...(c.assigneeId ? { assignedTo: Number(c.assigneeId) } : {}) })
    })

    let last: any
    for (const body of bodies) last = ensureOk(await ApiUpdateTodoChecklist(params, body))
    return last
}

export async function deleteTodoTask(task: TodoTask) {
    return ensureOk(await ApiDeleteTodo(idParam(task)))
}

const prettyCode = (code: string) =>
    code.toLowerCase().split('_').filter(Boolean).map((w) => w[0].toUpperCase() + w.slice(1)).join(' ')

/** 'PENDING' -> 'Pending' using the loaded status labels, anything else -> 'Some Value'. */
const prettyValue = (v: string) => STATUS_BY_ID[v.toLowerCase()]?.label ?? (PRIORITIES[v.toLowerCase() as Priority]?.label ?? prettyCode(v))

/**
 * One sentence per activity row. The API sends { action, oldValue, newValue, note }.
 * When the action is a status code (ONGOING, ON_HOLD ...) it reads as a status change;
 * for any other action it falls back to "<Action>: old -> new", so new action types still show up.
 */
function activityText(a: any): string {
    // const action = String(a?.action ?? '')
    // const oldV = a?.oldValue ? String(a.oldValue) : ''
    // const newV = a?.newValue ? String(a.newValue) : ''
    // const isStatus = !!STATUS_BY_ID[action.toLowerCase()]
    // let text: string
    // if (isStatus) text = oldV ? `Changed status from ${prettyValue(oldV)} to ${prettyValue(newV || action)}` : `Set status to ${prettyValue(newV || action)}`
    // else if (oldV || newV) text = `${prettyCode(action)}: ${oldV ? prettyValue(oldV) : 'None'} → ${newV ? prettyValue(newV) : 'None'}`
    // else text = prettyCode(action)
    // return a?.note ? `${text}\n${a.note}` : text
    return a?.note
}

/** Activity log of one task (newest first). Same ?todoTaskId= param as the other task APIs. */
export async function loadActivity(taskId: string): Promise<ActivityEntry[]> {
    try {
        const response: any = await ApiGetTodoActivity(`?todoTaskId=${taskId}`)
        return (response?.data ?? [])
            .map((a: any): ActivityEntry => ({
                id: String(a.todoTaskActivityId),
                userId: knownUserId(a.performedBy), // keeps only id, name and profile picture
                type: 'history',
                text: activityText(a),
                createdAt: toIso(a.performedOn),
            }))
            .sort((x: ActivityEntry, y: ActivityEntry) => y.createdAt.localeCompare(x.createdAt))
    } catch (error) {
        console.error('Error during API call:', error)
        return []
    }
}

/** Fetch one task by id (filters the tasks API with todoTaskId), so a save doesn't reload the whole list. */
export async function loadTask(id: string): Promise<TodoTask | null> {
    try {
        const response: any = await ApiGetTodoTasks(`?todoTaskId=${id}`)
        const found = (response?.data ?? []).find((t: any) => String(t.todoTaskId) === String(id))
        return found ? mapApiTask(found) : null
    } catch (error) {
        console.error('Error during API call:', error)
        return null
    }
}

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

export const uid = () => Math.random().toString(36).slice(2, 10)

export const checklistProgress = (task: TodoTask) => ({
    done: task.checklist.filter((i) => i.isCompleted).length,
    total: task.checklist.length,
})

export const loggedHours = (task: TodoTask) =>
    Math.round((task.timeSpentMinutes / 60) * 100) / 100

/** 200 -> "3 h 20 min", 60 -> "1 h", 50 -> "50 min", 0 -> "0 min" */
export const formatMinutes = (m: number) => {
    const h = Math.floor(m / 60)
    const rest = m % 60
    return h ? (rest ? `${h} h ${rest} min` : `${h} h`) : `${rest} min`
}

export const formatDue = (iso: string | null) =>
    iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }) : 'No date'

export const formatDueLong = (iso: string | null) =>
    iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : 'No date'

/** Exact time in the viewer's own time zone, e.g. "29 Oct, 1:53 pm" (adds the year when it is not this year). */
export function formatDateTime(iso: string) {
    if (!iso) return ''
    const d = new Date(iso)
    return d.toLocaleString('en-AU', {
        day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true,
        ...(d.getFullYear() !== new Date().getFullYear() ? { year: 'numeric' } : {}),
    })
}

export function formatWhen(iso: string) {
    const then = new Date(iso)
    const mins = Math.round((Date.now() - then.getTime()) / 60000)
    if (mins < 1) return 'just now'
    if (mins < 60) return `${mins} min ago`
    if (mins < 60 * 24) return `${Math.round(mins / 60)} h ago`
    return then.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' })
}

export function nextTaskKey(tasks: TodoTask[]) {
    const max = tasks.reduce((m, t) => Math.max(m, Number(t.key.replace(/\D/g, '')) || 0), 0)
    return `TSK-${max + 1}`
}


export function applyPatch(task: TodoTask, rawPatch: TaskPatch, actorId: string = CURRENT_USER_ID): TodoTask {
    // assigneeIds (list, main first) and assigneeId (main) always move together; a lone assigneeId means "only this person"
    let patch = rawPatch
    if (patch.assigneeIds?.length) patch = { ...patch, assigneeId: patch.assigneeIds[0] }
    else if (patch.assigneeId && !patch.assigneeIds) patch = { ...patch, assigneeIds: [patch.assigneeId] }
    const now = new Date().toISOString()
    const history: ActivityEntry[] = []
    const log = (text: string) => history.push({ id: uid(), userId: actorId, type: 'history', text, createdAt: now })

    if (patch.status && patch.status !== task.status)
        log(`Changed status from ${STATUS_BY_ID[task.status]?.label ?? task.status} to ${STATUS_BY_ID[patch.status]?.label ?? patch.status}`)
    if (patch.assigneeId && patch.assigneeId !== task.assigneeId)
        log(`Reassigned from ${USER_BY_ID[task.assigneeId]?.name ?? 'Unassigned'} to ${USER_BY_ID[patch.assigneeId]?.name ?? 'Unassigned'}`)
    if (patch.priority && patch.priority !== task.priority)
        log(`Changed priority from ${PRIORITIES[task.priority].label} to ${PRIORITIES[patch.priority].label}`)

    return { ...task, ...patch, activity: [...(patch.activity ?? task.activity), ...history], updatedAt: now }
}

export function moveTask(
    tasks: TodoTask[],
    taskId: string,
    toStatus: StatusId,
    beforeId: string | null,
    actorId: string = CURRENT_USER_ID,
): TodoTask[] {
    const task = tasks.find((t) => t.id === taskId)
    if (!task) return tasks
    const rest = tasks.filter((t) => t.id !== taskId)
    const moved = applyPatch(task, { status: toStatus }, actorId)
    const at = beforeId ? rest.findIndex((t) => t.id === beforeId) : -1
    if (at < 0) return [...rest, moved]
    return [...rest.slice(0, at), moved, ...rest.slice(at)]
}